import AlertIcon from "./alert.svg";
import AngleDownIcon from "./angle-down.svg";
import AngleUpIcon from "./angle-up.svg";
import ArrowDownIcon from "./arrow-down.svg";
import ArrowRightIcon from "./arrow-right.svg";
import ArrowUpIcon from "./arrow-up.svg";
import AudioIcon from "./audio.svg";
import BellIcon from "./bell.svg";
import BoltIcon from "./bolt.svg";
import BoxCubeIcon from "./box-cube.svg";
import BoxIconLine from "./box-line.svg";
import BoxIcon from "./box.svg";
import CalenderIcon from "./calender-line.svg";
import ChatIcon from "./chat.svg";
import CheckCircleIcon from "./check-circle.svg";
import CheckLineIcon from "./check-line.svg";
import ChevronDownIcon from "./chevron-down.svg";
import ChevronLeftIcon from "./chevron-left.svg";
import ChevronUpIcon from "./chevron-up.svg";
import CloseLineIcon from "./close-line.svg";
import CloseIcon from "./close.svg";
import CopyIcon from "./copy.svg";
import DocsIcon from "./docs.svg";
import DollarLineIcon from "./dollar-line.svg";
import DownloadIcon from "./download.svg";
import EnvelopeIcon from "./envelope.svg";
import ExternalLinkIcon from "./external-link.svg";
import EyeCloseIcon from "./eye-close.svg";
import EyeIcon from "./eye.svg";
import FileIcon from "./file.svg";
import FolderIcon from "./folder.svg";
import GridIcon from "./grid.svg";
import GroupIcon from "./group.svg";
import HorizontaLDots from "./horizontal-dots.svg";
import ErrorIcon from "./info-hexa.svg";
import InfoIcon from "./info.svg";
import ListIcon from "./list.svg";
import LockIcon from "./lock.svg";
import MailIcon from "./mail-line.svg";
import MoreDotIcon from "./more-dot.svg";
import PageIcon from "./page.svg";
import PaperPlaneIcon from "./paper-plane.svg";
import PencilIcon from "./pencil.svg";
import PieChartIcon from "./pie-chart.svg";
import PlugInIcon from "./plug-in.svg";
import PlusIcon from "./plus.svg";
import ShootingStarIcon from "./shooting-star.svg";
import TableIcon from "./table.svg";
import TaskIcon from "./task-icon.svg";
import TimeIcon from "./time.svg";
import TrashBinIcon from "./trash.svg";
import UserCircleIcon from "./user-circle.svg";
import UserIcon from "./user-line.svg";
import VideoIcon from "./videos.svg";

export {
  AlertIcon, AngleDownIcon, AngleUpIcon, ArrowDownIcon,
  ArrowRightIcon, ArrowUpIcon, AudioIcon, BellIcon, BoltIcon, BoxCubeIcon, BoxIcon, BoxIconLine, CalenderIcon, ChatIcon, CheckCircleIcon, CheckLineIcon, ChevronDownIcon, ChevronLeftIcon, ChevronUpIcon, CloseIcon, CloseLineIcon, CopyIcon, DocsIcon, DollarLineIcon, DownloadIcon, EnvelopeIcon, ErrorIcon, ExternalLinkIcon, EyeCloseIcon, EyeIcon, FileIcon, FolderIcon, GridIcon, GroupIcon, HorizontaLDots, InfoIcon, ListIcon, LockIcon, MailIcon, MoreDotIcon, PageIcon, PaperPlaneIcon, PencilIcon, PieChartIcon, PlugInIcon, PlusIcon, ShootingStarIcon, TableIcon, TaskIcon, TimeIcon, TrashBinIcon, UserCircleIcon, UserIcon, VideoIcon
};

